export enum CacheTime {
  Day = 86400 * 1000,
  Hour = 3600 * 1000,
  Minute = 60 * 1000,
  Week = 7 * 24 * 3600 * 1000
}

export class RuntimeCache {
  #cache = new Map<string, { until: number; value: unknown }>();

  public set(key: string, value: unknown, ttl: number) {
    this.#cache.set(key, { until: Date.now() + ttl, value });
  }

  public get<T = any>(key: string): T | undefined {
    const item = this.#cache.get(key);
    if (item && item.until > Date.now()) {
      return item.value as T;
    }

    this.#cache.delete(key);
    return undefined;
  }

  public async run<R extends any>(key: string, resolveCallback: () => R, ttl: number): Promise<Awaited<R>> {
    if (this.has(key)) {
      return this.get(key) as Promise<Awaited<R>>;
    }

    const value = await resolveCallback();
    this.set(key, value, ttl);
    return value;
  }

  public has(key: string) {
    const item = this.#cache.get(key);
    return item && item.until > Date.now();
  }

  public invalidate(key: string | ((key: string) => boolean)) {
    if (typeof key === 'function') {
      for (const [k] of this.#cache.entries()) {
        if (key(k)) {
          this.#cache.delete(k);
        }
      }
      return;
    }

    this.#cache.delete(key);
  }
}
